import { ShieldCheck } from "lucide-react";
import { fmt } from "@/lib/format";

export default function TokenCertificate({ brick, property, ownerName }) {
  return (
    <div className="cert-bg border border-[#D4AF37]/40 rounded-2xl p-6 relative overflow-hidden grain" data-testid={`certificate-${brick.id}`}>
      <div className="flex items-start justify-between gap-4 mb-6">
        <div>
          <div className="overline">Certificate of Ownership</div>
          <div className="font-heading text-xl text-white mt-1">{property?.name || "Property"}</div>
          <div className="text-xs text-gray-400">{property?.location}</div>
        </div>
        <div className="w-10 h-10 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/40 flex items-center justify-center">
          <ShieldCheck className="w-5 h-5 text-[#D4AF37]" />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 text-sm">
        <div>
          <div className="overline mb-1">Token ID</div>
          <div className="font-mono text-[#D4AF37] text-sm break-all">{brick.token_id}</div>
        </div>
        <div>
          <div className="overline mb-1">Brick #</div>
          <div className="font-mono text-white">{String(brick.brick_number).padStart(5, "0")}</div>
        </div>
        <div>
          <div className="overline mb-1">Owner</div>
          <div className="text-white truncate">{ownerName || brick.owner_name || "—"}</div>
        </div>
        <div>
          <div className="overline mb-1">Purchase price</div>
          <div className="font-mono text-white">${brick.purchase_price?.toFixed(2) || "—"}</div>
        </div>
        <div className="col-span-2">
          <div className="overline mb-1">Issued</div>
          <div className="text-xs text-gray-300">
            {brick.purchased_at ? new Date(brick.purchased_at).toLocaleString() : "—"}
          </div>
        </div>
      </div>

      <div className="mt-6 pt-4 border-t border-white/10 flex items-center justify-between">
        <div className="text-[10px] tracking-[0.3em] text-gray-500 uppercase">Blockchain Properties Ltd</div>
        <div className="text-[10px] font-mono text-gray-500">VERIFIED • ON-LEDGER</div>
      </div>
    </div>
  );
}
